<script>
	import HomeDashboard from '../components/HomeDashboard.svelte';
    import Loading from "../components/Loading.svelte";
    import Menu from "../components/Menu.svelte";
    import Register from "../components/Register.svelte";
    import { connected, isConnectedVar } from "../store";
</script>

{#await $isConnectedVar}
    <Loading />
{:then}
    {#key $connected}
        {#if !$connected}
            <Register />
        {:else}
            <Menu />
            <HomeDashboard />
        {/if}
    {/key}
{:catch error}
    {error.message}
{/await}
